export const MyLowesRewardsJSInjection = 'my_lowes_rewards_js_injection'
